import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay } from "@chakra-ui/react";
import { CandidateIdsContext } from "../CandidatePage/CandidateIdsContext";
import { CandidatePageContent } from "../CandidatePage/CandidatePage";

interface CandidateDrawerProps {
    clientId: string;
    entityId: string | undefined;
    candidateId: string | undefined;
    onClose: () => void;
}

export function CandidateDrawer({ clientId, entityId, candidateId, onClose }: CandidateDrawerProps) {
    const isOpen = !!candidateId && !!entityId;

    return (
        <Drawer isOpen={isOpen} onClose={onClose} size="full" placement="right">
            <DrawerOverlay />
            <DrawerContent overflowY="auto">
                {/* Thin header just to give the close button room */}
                <DrawerHeader px={4} py={2} borderBottomWidth={1} fontSize="sm" color="gray.500">
                    Candidate Details
                </DrawerHeader>
                <DrawerCloseButton top={2} />
                {isOpen && (
                    <CandidateIdsContext.Provider value={{ cId: clientId, eId: entityId, candidateId }}>
                        <DrawerBody pt="1.5rem" pb="2rem">
                            <CandidatePageContent onBack={onClose} onMoveSuccess={onClose} showBreadcrumb={false} />
                        </DrawerBody>
                    </CandidateIdsContext.Provider>
                )}
            </DrawerContent>
        </Drawer>
    );
}
